var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{staticClass:"banners",attrs:{"height":"560px","interval":4000,"arrow":"always"}},_vm._l((_vm.bannerList),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{staticClass:"wow animate fadeIn",attrs:{"data-wow-duration":"3s","src":(item.url),"alt":""}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }